import React, { useEffect, useState } from 'react';
import { getFramework, useActiveOriginIndex, useIdentity, useScale } from '@/framework';
import { IExportPlugin, ILayerProps, PluginType } from '@/version-types';
import stageGridPluginState, { useStageGridStore } from './models/stage-grid-state';
import { StageGridPlugin } from './stage-grid';
import GridLineOperate from './views/grid-lines/grid-line-operate';
import GridLines from './views/grid-lines/grid-lines';

const StageGridPluginView = React.memo(() => {
    const activeOriginIndex = useActiveOriginIndex();

    const identity = useIdentity();
    const framework = getFramework(identity);
    const scale = useScale();
    const [stageSize, setStageSize] = useState({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        const setSize = (bgLayer: ILayerProps | null) => {
            if (!bgLayer) {
                return;
            }
            setStageSize({
                width: bgLayer.width,
                height: bgLayer.height,
            });
        };
        setSize(framework.getBackgroundLayer(activeOriginIndex));
        const handler = framework.events.onStageResize(() => {
            setSize(framework.getBackgroundLayer(activeOriginIndex));
        });

        return () => {
            framework.events.off(handler);
        };
    }, []);

    const showGridLineOperate = useStageGridStore()((state) => state.showGridLineOperate);
    if (!showGridLineOperate) {
        return null;
    }
    return (
        <div className="stage-grid-plugin-wrap">
            <GridLineOperate />
            <div
                style={{
                    width: stageSize.width,
                    height: stageSize.height,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: `translate(-50%, -50%) scale(${scale})`,
                    pointerEvents: 'none',
                }}
            >
                <GridLines width={stageSize.width} height={stageSize.height} />
            </div>
        </div>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: -1,
    name: 'stage-grid-plugin',
    render() {
        return <StageGridPluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'StageGridPlugin', value: new StageGridPlugin(identity) }];
    },
    createState() {
        return [stageGridPluginState];
    },
};

export default exportPlugin;
